import React, { useEffect, useState } from 'react';
import ContenedorProductosServicios from '../ProductosServicios/ContenedorProductosServicios';

function PaginatedItems({
  itemsPerPage,
  itemsPS,
  totalItems,
  currentPage,
  onPageChange,
  type,
}) {

  // Calcular el número total de páginas
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simula el tiempo de carga
    setIsLoading(true);
    const timeout = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timeout);
  }, [itemsPS, currentPage]);
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  const startIndex = 0;
  const endIndex = Math.min(startIndex + itemsPerPage, itemsPS.length);


  // Obtener los elementos correspondientes a la página actual
  const currentItems = itemsPS.slice(startIndex, endIndex);


  // Retornar el componente con los productos actuales
  return (
    <ContenedorProductosServicios
      itemsPS={currentItems}       // Elementos filtrados para la página actual
      pageCount={pageCount}        // Número total de páginas
      currentPage={currentPage}    // Página actual (pasada desde el padre)
      onPageChange={onPageChange}  // Manejador del cambio de página
      type={type}                  // Tipo de contenido para personalización
      isLoading={isLoading} // Enviar estado de carga al contenedor
    />
  );
}

export default PaginatedItems;
